import { MantineProvider } from "@mantine/core";
import "@mantine/core/styles.css";
import "@mantine/charts/styles.css";
import "@mantine/dates/styles.css";
import "@mantine/notifications/styles.css";
import "@mantine/spotlight/styles.css";

import "@ngt-form/mantine/dist/index.css";
import "@ngt/mantine-react-table/dist/index.css";
import "./styles/app.scss";
import { Notifications } from "@mantine/notifications";
import { createRoot } from "react-dom/client";
import { SWRConfig } from "swr";
import "react-scan";

import "src/sentry";
import mantineFormOptions from "src/mantineFormOptions";
import { DatesProvider } from "@mantine/dates";

import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
import "dayjs/locale/en-au";
import { StrictMode } from "react";
import ServiceStackClientProvider from "src/components/providers/api/ServiceStackClientProvider";
import { FormAdapterProvider } from "@ngt-form/core";
import { MutativeFormAdapter } from "@ngt-form/mutative";
import AuthenticatedUserProvider from "src/components/providers/authentication/AuthenticatedUserProvider";
import { MantineFormOptionsProvider } from "@ngt-form/mantine";
import mantineTheme from "src/styles/mantineTheme";
import { mantineCssResolver } from "src/styles/mantineCssResolver";
import AppSettings from "./AppSettings";
import App from "./App";

dayjs.extend(relativeTime);

const root = createRoot(document.getElementById("app") as HTMLDivElement);
root.render(
    <StrictMode>
        {/* <Sentry.ErrorBoundary fallback={<>An error has occured. Please refresh the page and try again.</>}> */}
        <SWRConfig
            value={{
                revalidateOnFocus: false,
                revalidateOnReconnect: false,
                shouldRetryOnError: false,
            }}
        >
            <MantineProvider theme={mantineTheme} cssVariablesResolver={mantineCssResolver}>
                <DatesProvider settings={{ locale: "en-au" }}>
                    <MantineFormOptionsProvider options={mantineFormOptions}>
                        <ServiceStackClientProvider
                            baseUrl={AppSettings.client.baseUrl}
                            basePath={AppSettings.client.basePath}
                        >
                            <FormAdapterProvider adapter={MutativeFormAdapter}>
                                <AuthenticatedUserProvider
                                    configuration={{
                                        revalidateOnFocus: true,
                                        revalidateOnReconnect: true,
                                    }}
                                >
                                    <Notifications
                                        position="bottom-right"
                                        limit={5}
                                        autoClose={5000}
                                    />
                                    <App />
                                </AuthenticatedUserProvider>
                            </FormAdapterProvider>
                        </ServiceStackClientProvider>
                    </MantineFormOptionsProvider>
                </DatesProvider>
            </MantineProvider>
        </SWRConfig>
        {/* </Sentry.ErrorBoundary> */}
    </StrictMode>,
);
